<span
  class="cropped tw-flex tw-items-center"
  [matTooltip]="
    time
      ? (time.timestamp | locale : dateFormat : time.timezone | nullToNotAvailable) +
        '&#13;' +
        time.timezone +
        (time.resolved ? '' : '&#13;' + ('common.message.timezoneIsNotResolved' | translate))
      : notAvailable
  "
>
  {{ 'common.uiKit.monitoring.dateShortcut.' + timeTitleKey | translate }}:

  <ui-svg-icon
    *ngIf="time?.resolved === false"
    [name]="iconNameList.AlertInfo"
    class="timezone-alert tw-ml-2"
  ></ui-svg-icon>
  {{ time ? (time.timestamp | locale : dateFormat : time.timezone | nullToNotAvailable) : notAvailable }}
</span>
